{
  "countries": {
    "AF": "Afghanistan",
    "AX": "Ålandeilanden",
    "AL": "Albanië",
    "DZ": "Algerije",
    "AS": "Amerikaans-Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua en Barbuda",
    "AR": "Argentinië",
    "AM": "Armenië",
    "AW": "Aruba",
    "AC": "Ascension",
    "AU": "Australië",
    "AT": "Oostenrijk",
    "AZ": "Azerbeidzjan",
    "BS": "Bahama's",
    "BH": "Bahrein",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "België",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia",
    "BA": "Bosnië en Herzegovina",
    "BW": "Botswana",
    "BR": "Brazilië",
    "IO": "Brits Indische Oceaanterritorium",
    "VG": "Britse Maagdeneilanden",
    "BN": "Brunei",
    "BG": "Bulgarije",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodja",
    "CM": "Kameroen",
    "CA": "Canada",
    "IC": "Canarische Eilanden",
    "CV": "Kaapverdië",
    "BQ": "Caribisch Nederland",
    "KY": "Kaaimaneilanden",
    "CF": "Centraal-Afrikaanse Republiek",
    "EA": "Ceuta en Melilla",
    "TD": "Tsjaad",
    "CL": "Chili",
    "CN": "China",
    "CX": "Christmaseiland",
    "CC": "Cocoseilanden",
    "CO": "Colombia",
    "KM": "Comoren",
    "CG": "Congo-Brazzaville",
    "CD": "Congo-Kinshasa",
    "CK": "Cookeilanden",
    "CR": "Costa Rica",
    "CI": "Ivoorkust",
    "HR": "Kroatië",
    "CU": "Cuba",
    "CW": "Curaçao",
    "CY": "Cyprus",
    "CZ": "Tsjechië",
    "DK": "Denemarken",
    "DG": "Diego Garcia",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominicaanse Republiek",
    "EC": "Ecuador",
    "EG": "Egypte",
    "SV": "El Salvador",
    "GQ": "Equatoriaal-Guinea",
    "ER": "Eritrea",
    "EE": "Estland",
    "SZ": "Eswatini",
    "ET": "Ethiopië",
    "FK": "Falklandeilanden",
    "FO": "Faeröer",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "Frankrijk",
    "GF": "Frans-Guyana",
    "PF": "Frans-Polynesië",
    "TF": "Franse Zuidelijke en Antarctische Gebieden",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgië",
    "DE": "Duitsland",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Griekenland",
    "GL": "Groenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinee",
    "GW": "Guinee-Bissau",
    "GY": "Guyana",
    "HT": "Haïti",
    "HN": "Honduras",
    "HK": "Hongkong SAR van China",
    "HU": "Hongarije",
    "IS": "IJsland",
    "IN": "India",
    "ID": "Indonesië",
    "IR": "Iran",
    "IQ": "Irak",
    "IE": "Ierland",
    "IM": "Man",
    "IL": "Israël",
    "IT": "Italië",
    "JM": "Jamaica",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordanië",
    "KZ": "Kazachstan",
    "KE": "Kenia",
    "KI": "Kiribati",
    "XK": "Kosovo",
    "KW": "Koeweit",
    "KG": "Kirgizië",
    "LA": "Laos",
    "LV": "Letland",
    "LB": "Libanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libië",
    "LI": "Liechtenstein",
    "LT": "Litouwen",
    "LU": "Luxemburg",
    "MO": "Macau SAR van China",
    "MG": "Madagaskar",
    "MW": "Malawi",
    "MY": "Maleisië",
    "MV": "Maldiven",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshalleilanden",
    "MQ": "Martinique",
    "MR": "Mauritanië",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia",
    "MD": "Moldavië",
    "MC": "Monaco",
    "MN": "Mongolië",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Marokko",
    "MZ": "Mozambique",
    "MM": "Myanmar (Birma)",
    "NA": "Namibië",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Nederland",
    "NC": "Nieuw-Caledonië",
    "NZ": "Nieuw-Zeeland",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk",
    "KP": "Noord-Korea",
    "MK": "Noord-Macedonië",
    "MP": "Noordelijke Marianen",
    "NO": "Noorwegen",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestijnse gebieden",
    "PA": "Panama",
    "PG": "Papoea-Nieuw-Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Filipijnen",
    "PN": "Pitcairneilanden",
    "PL": "Polen",
    "PT": "Portugal",
    "XA": "Pseudo-Accents",
    "XB": "Pseudo-Bidi",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Roemenië",
    "RU": "Rusland",
    "RW": "Rwanda",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tomé en Principe",
    "SA": "Saoedi-Arabië",
    "SN": "Senegal",
    "RS": "Servië",
    "SC": "Seychellen",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SX": "Sint-Maarten",
    "SK": "Slowakije",
    "SI": "Slovenië",
    "SB": "Salomonseilanden",
    "SO": "Somalië",
    "ZA": "Zuid-Afrika",
    "GS": "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
    "KR": "Zuid-Korea",
    "SS": "Zuid-Soedan",
    "ES": "Spanje",
    "LK": "Sri Lanka",
    "BL": "Saint-Barthélemy",
    "SH": "Sint-Helena",
    "KN": "Saint Kitts en Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint-Martin",
    "PM": "Saint-Pierre en Miquelon",
    "VC": "Saint Vincent en de Grenadines",
    "SD": "Soedan",
    "SR": "Suriname",
    "SJ": "Spitsbergen en Jan Mayen",
    "SE": "Zweden",
    "CH": "Zwitserland",
    "SY": "Syrië",
    "TW": "Taiwan",
    "TJ": "Tadzjikistan",
    "TZ": "Tanzania",
    "TH": "Thailand",
    "TL": "Oost-Timor",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad en Tobago",
    "TA": "Tristan da Cunha",
    "TN": "Tunesië",
    "TR": "Turkije",
    "TM": "Turkmenistan",
    "TC": "Turks- en Caicoseilanden",
    "TV": "Tuvalu",
    "UG": "Oeganda",
    "UA": "Oekraïne",
    "AE": "Verenigde Arabische Emiraten",
    "GB": "Verenigd Koninkrijk",
    "US": "Verenigde Staten",
    "UY": "Uruguay",
    "UM": "Kleine afgelegen eilanden van de Verenigde Staten",
    "VI": "Amerikaanse Maagdeneilanden",
    "UZ": "Oezbekistan",
    "VU": "Vanuatu",
    "VA": "Vaticaanstad",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "WF": "Wallis en Futuna",
    "EH": "Westelijke Sahara",
    "YE": "Jemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  }
}
